import React from "react";
import DepartmentDetails from "../../components/features/departments/DepartmentDetails";

const DepartmentDetailsPage = () => {
  return <DepartmentDetails />;
};

export default DepartmentDetailsPage;
